import React, { FC, useEffect, useMemo } from 'react';
import { MainpageBrand } from './MainpageBrand';
import { useAdfoxContext } from '../../../external/context/AdfoxContext';
import dompurify from 'isomorphic-dompurify';
import { useBackgroundContext } from '../../../../BackgroundProvider';
import { TMainpageBrandContext } from '../../../types';
import { useMainPageBrandBannerEnrichments } from './useMainPageBrandBannerEnrichments';

type MainpageBrandContainerProps = {
  context: TMainpageBrandContext;
};

export const MainpageBrandContainer: FC<MainpageBrandContainerProps> = ({ context }) => {
  const { sizes } = useAdfoxContext();
  const [, setBackgroundImg] = useBackgroundContext();

  const {
    mortgageTermsWarning,
    mortgageWarning,
    name,
    phone,
    actionText,
    info,
    logoImageUrl,
    label,
    substrateNotNeeded,
    url,
    buttonText = 'Узнать цены',
    note,
    bgImageUrl,
  } = context;

  const mainPageBrandBannerEnrichments = useMainPageBrandBannerEnrichments(context);

  const sanitizedName = useMemo(() => name && dompurify.sanitize(name), [name]);
  const sanitizedPhone = useMemo(() => phone && dompurify.sanitize(phone), [phone]);
  const sanitizedActionText = useMemo(() => actionText && dompurify.sanitize(actionText), [actionText]);
  const sanitizedInfo = useMemo(() => {
    const infoText = mainPageBrandBannerEnrichments?.title || info;

    return infoText && dompurify.sanitize(infoText);
  }, [info, mainPageBrandBannerEnrichments?.title]);

  useEffect(() => {
    if (bgImageUrl) {
      setBackgroundImg(bgImageUrl);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <MainpageBrand
      label={label}
      url={url}
      substrateNotNeeded={substrateNotNeeded}
      logoImageUrl={logoImageUrl}
      sizes={sizes}
      buttonText={buttonText}
      sanitizedActionText={sanitizedActionText}
      sanitizedName={sanitizedName}
      sanitizedPhone={sanitizedPhone}
      sanitizedInfo={sanitizedInfo}
      mortgageTermsWarning={mortgageTermsWarning}
      mortgageWarning={mortgageWarning}
      note={note}
    />
  );
};
